import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../setup'

type SelectorFunc<T> = (state: RootState) => T

export const useRootStateSelector = <T>(selector: SelectorFunc<T>) => {
  return useSelector<RootState, T>(selector, shallowEqual)
}
